import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "../../common/Button/Button";

class Actions extends Component {
  render() {
    const { checkedItems = [], checkedItemActions } = this.props;
    const hasCheckedItems = checkedItems.length > 0;
    return (
      <div>
        {hasCheckedItems ? (
          <div className="row mt20 mb-3">
            {checkedItemActions.map((a) => {
              return (
                <div className="col-auto">
                  <Button onClick={a.onClick}>{a.text}</Button>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="row mt20 justify-content-between">
            <div className="col-md-10 col-lg-10">
              <div className="input-group mb-3 search-input">
                {/* <div className="input-group-prepend">
                    <Select className="w150" placeholder="Filter Type" />
                  </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search users..."
                /> */}
              </div>
            </div>
            <div className="col-auto mb-3">
              <Button onClick={this.props.onPrimaryActionClick}>
                Create User
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Actions;
Actions.propTypes = {
  checkedItems: PropTypes.array,
  deleteItem: PropTypes.shape({
    text: PropTypes.string,
    onDeleteItem: PropTypes.func,
  }),
  importItems: PropTypes.shape({
    text: PropTypes.string,
    onImportItems: PropTypes.func,
  }),
  addItem: PropTypes.shape({
    text: PropTypes.string,
    onAddItem: PropTypes.func,
  }),
};
